import { render, staticRenderFns } from "./GiftSummary.vue?vue&type=template&id=c7290386&"
import script from "./GiftSummary.vue?vue&type=script&lang=ts&"
export * from "./GiftSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports